module.exports = __webpack_public_path__ + "assets/images/Transfer-On.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Transfer-On.png
// module id = 394
// module chunks = 1